import React from "react";
import { Tag } from "design-system";

function BetaCard() {
  return (
    <Tag isClosable={false} size="md">
      Beta
    </Tag>
  );
}

export default BetaCard;
